import React from 'react';
import { IconProps } from '.';

const SvgSortDesc = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M7.617 16.383V4.75h-1.5v11.746l-2.306-2.307L2.75 15.25l4.06 4.06 4.061-4.06-1.06-1.06-2.194 2.193ZM12.25 7.25h9v-1.5h-9v1.5ZM12.25 10.75h7.5v-1.5h-7.5v1.5ZM18.25 14.25h-6v-1.5h6v1.5ZM12.25 17.75h4v-1.5h-4v1.5Z'
      />
    </svg>
  );
};

export default SvgSortDesc;
